/** @type {import('./isFeedPostType').isPostFeedType} */
const isPostFeedType = (postType, data) => {
  return data?.post_type === postType;
};

export { isPostFeedType };
